import React from 'react';
import format from 'string-template';
import { connect } from 'react-redux';
import { length } from 'redux-form-validators';
import { toPlainObject, isEmpty } from 'lodash';

import { APP_NAME } from '../../../../constants';

import { sendProfileUpdateRequest, reset } from '../../../../services/account/myprofile/actions';

import {
    FormComponent,
    TextInputFieldComponent,
    EmailInputFieldComponent,
    LegendFieldComponent,
    RadioInputFieldComponent
} from '../../../../components/form';

const FORM_NAME = 'profile-form';

class ProfileFormComponent extends React.Component {
    submit = formData => {
        const { sendProfileUpdateRequest, reset } = this.props;
        sendProfileUpdateRequest(formData, () => {
            setTimeout(() => {
                reset();
            }, 3000);
        });
    };

    render() {
        const {
            i18n,
            i18nForm,
            isAuthed,
            initialValues,
            errorMessage,
            requestSubmit,
            errorSubmit,
            successSubmit
        } = this.props;

        return (
            <FormComponent
                form={FORM_NAME}
                initialValues={isAuthed ? initialValues : {}}
                classNameInputContainer="grid-3 has-gutter"
                onSubmit={this.submit}
                requestSubmit={requestSubmit}
                errorSubmit={errorSubmit}
                submitText={i18n.BUTTON_VALIDATE}>
                <TextInputFieldComponent
                    name="lastname"
                    label={i18nForm.LABEL_LASTNAME}
                    placeholder={i18nForm.LABEL_LASTNAME}
                    classNameInputContainer="one-half mr50"
                    validate={[length({ max: 20, msg: i18nForm.LASTNAME_SIZE_ERROR })]}
                    readOnly
                />
                <TextInputFieldComponent
                    name="firstname"
                    label={i18nForm.LABEL_FIRSTNAME}
                    placeholder={i18nForm.LABEL_FIRSTNAME}
                    classNameInputContainer="one-half mr50"
                    validate={[length({ max: 20, msg: i18nForm.FIRSTNAME_SIZE_ERROR })]}
                    readOnly
                />
                <EmailInputFieldComponent
                    label={i18n.LABEL_EMAIL}
                    name="email"
                    classNameInputContainer="one-half"
                    readOnly
                />

                <RadioInputFieldComponent
                    name="activeMailingOffer"
                    label={format(i18n.TEXT_NEWSLETTER, APP_NAME)}
                    options={[
                        { label: i18n.OPTION_YES_NEWSLETTER, value: true },
                        { label: i18n.OPTION_NO_NEWSLETTER, value: false }
                    ]}
                    classNameInputContainer="three-quarters"
                />

                <LegendFieldComponent classNameInputContainer="full txtright">
                    {i18nForm.TEXT_REQUIRED_FIELD}
                </LegendFieldComponent>
                {errorMessage && (
                    <LegendFieldComponent classNameInputContainer="color-err message full">
                        {errorMessage}
                    </LegendFieldComponent>
                )}
                {successSubmit && (
                    <LegendFieldComponent classNameInputContainer="color-succ form-success-message message full">
                        {i18n.SUBMIT_SUCCEEDED}
                    </LegendFieldComponent>
                )}
            </FormComponent>
        );
    }
}

function mapStateToProps(state) {
    const user = toPlainObject(state.account.user);

    return {
        i18nForm: state.i18n.feature.form,
        i18n: state.i18n.page.ACCOUNT.PROFILE,
        isAuthed: !isEmpty(state.authentication.token),
        initialValues: {
            lastname: user.lastname ? user.lastname : '',
            firstname: user.firstname ? user.firstname : '',
            email: user.email ? user.email : '',
            activeMailingOffer:
                user.activeMailingOffer && user.activeMailingOffer === true ? 'true' : 'false'
        },
        errorMessage: state.account.myprofile.error,
        requestSubmit: state.account.myprofile.fetching,
        errorSubmit: !isEmpty(state.account.myprofile.errorMessage),
        successSubmit: state.account.myprofile.successProfileUpdateRequestSubmit
    };
}

const mapDispatchtoProps = {
    sendProfileUpdateRequest,
    reset
};

export default connect(mapStateToProps, mapDispatchtoProps)(ProfileFormComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/myprofile/ProfileFormComponent.js